import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Bus shelter, 2x1 tiles: glass back and sides on slim black posts under a
// flat roof, a narrow bench slab inside and a small sign panel on the roof
// edge. Open front faces +Z (the kerb side).
const BLACK = "#2e2e30";
const GLASS = "#9fc4d4";
const PLANK = "#c8975a";
const RED = "#b04a3a";
const WHITE = "#e8e6e0";

export const busStop = defineModel({
  id: "bus-stop",
  batchId: "modern",
  name: "Bus stop",
  tags: ["modern", "outdoor", "street", "shelter", "transit", "seating"],
  summary: "A glass bus shelter with a bench and a roof sign.",
  description:
    "A bus shelter of the Modern Living kit, spanning 2x1 tiles: glass back " +
    "and side panels on slim matte-black posts under a flat roof, a narrow " +
    "bench slab inside and a small sign panel standing on the roof edge. The " +
    "open front faces +Z — place it with the road on the +Z side.",
  tiles: { w: 2, h: 1 },
  footprint: 1.3,
  parts(): Part[] {
    const posts: Part[] = [];
    for (const x of [-0.87, 0.87]) {
      for (const z of [-0.42, 0.42]) {
        posts.push({
          geometry: new THREE.BoxGeometry(0.07, 2.25, 0.07),
          color: BLACK,
          position: [x, 1.125, z],
        });
      }
    }
    return [
      ...posts,
      // Flat roof.
      {
        geometry: new THREE.BoxGeometry(1.94, 0.07, 1.0),
        color: BLACK,
        position: [0, 2.29, 0],
      },
      // Glass back panel.
      {
        geometry: new THREE.BoxGeometry(1.74, 1.95, 0.03),
        color: GLASS,
        position: [0, 1.1, -0.42],
      },
      // Glass side panels.
      {
        geometry: new THREE.BoxGeometry(0.03, 1.95, 0.78),
        color: GLASS,
        position: [-0.87, 1.1, 0],
      },
      {
        geometry: new THREE.BoxGeometry(0.03, 1.95, 0.78),
        color: GLASS,
        position: [0.87, 1.1, 0],
      },
      // Bench slab and its two supports.
      {
        geometry: new THREE.BoxGeometry(1.5, 0.06, 0.32),
        color: PLANK,
        position: [0, 0.46, -0.24],
      },
      {
        geometry: new THREE.BoxGeometry(0.06, 0.43, 0.26),
        color: BLACK,
        position: [-0.6, 0.215, -0.24],
      },
      {
        geometry: new THREE.BoxGeometry(0.06, 0.43, 0.26),
        color: BLACK,
        position: [0.6, 0.215, -0.24],
      },
      // Sign panel standing on the roof's front edge.
      {
        geometry: new THREE.BoxGeometry(0.52, 0.3, 0.05),
        color: RED,
        position: [-0.6, 2.47, 0.44],
      },
      {
        geometry: new THREE.BoxGeometry(0.4, 0.14, 0.02),
        color: WHITE,
        position: [-0.6, 2.47, 0.475],
      },
    ];
  },
  animations: [],
});
